import { encodePeriodValue, GlobalPeriodSelect } from '@components'

import { Flex, Spacing } from '@billy/design-system'
import { useCallback } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { PeriodValue } from '../../../../../../../types/periodValue'
import { ViewSettings } from '../../../../../../reports/elements/ViewSettings'
import { SettingsAction } from '../../../../../../reports/enums/settingsAction'
import { ExpandButton } from '../../../../../elements/ExpandButton'
import { useTrialBalanceFilters } from '../../contexts/trialBalanceFiltersContext'

export const TrialBalanceActions = () => {
  const { organization } = useUserOrganization()
  const { appliedFilters, setQueryParams } = useTrialBalanceFilters()

  const handlePeriodChange = useCallback(
    (periodValue: PeriodValue) => {
      if (!organization?.id) {
        return
      }
      const periodValueEncoded = periodValue ? encodePeriodValue(periodValue, organization.id) : undefined

      setQueryParams({ period: periodValueEncoded })
    },
    [organization?.id, setQueryParams],
  )

  return (
    <Flex justifyContent="space-between" gap={Spacing.S6}>
      <GlobalPeriodSelect encodedPeriod={appliedFilters.period} onChange={handlePeriodChange} />
      <ExpandButton />
      <ViewSettings
        appliedFilters={appliedFilters}
        setQueryParams={setQueryParams}
        availableSettings={[SettingsAction.HideZeros]}
      />
    </Flex>
  )
}
